import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "../../utils/axios";
import toast from "react-hot-toast";
import Sidebar from "./sidebar";
import { User, Clock, ArrowLeft } from "lucide-react";

const UserDetail = () => {
  const { id } = useParams();
  const [logs, setLogs] = useState([]);
  const [userName, setUserName] = useState(null);

  const fetchUserDetail = async () => {
    try {
      const res = await axios.get(`/properties/logs?userId=${id}`);
      const logsData = res.data.data || [];
      setLogs(logsData);

      // if logs exist, get user_name from first log
      if (logsData.length > 0) {
        setUserName(logsData[0].user_name || "Unknown User");
      }
    } catch (err) {
      toast.error("Failed to load user details");
    }
  };

  useEffect(() => {
    fetchUserDetail();
  }, [id]);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="p-8 flex-1 overflow-y-auto">
        {/* Back button */}
        <Link
          to="/superadmin/Users"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to Users
        </Link>

        {/* User Header */}
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
            <User className="w-7 h-7 text-blue-600" />
            {userName || `User ${id}`}
          </h1>
          <p className="text-gray-500 mt-2">
            Overview of all property actions performed by this user.
          </p>
        </div>

        {/* Logs Section */}
        <div className="mt-8">
          <h2 className="text-xl font-semibold mb-4 text-gray-800">
            Activity Logs
          </h2>

          {logs.length === 0 ? (
            <p className="text-gray-500 italic">No logs available.</p>
          ) : (
            <ul className="space-y-4">
              {logs.map((log) => {
                let details = {};
                try {
                  details = JSON.parse(log.details || "{}");
                } catch {
                  details = {};
                }

                return (
                  <li
                    key={log.id}
                    className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <span className="px-3 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-700">
                          {log.action}
                        </span>
                        <span className="text-sm text-gray-600">
                          Property:{" "}
                          <span className="font-medium text-gray-800">
                            {log.property_pin || "-"}
                          </span>
                        </span>
                      </div>
                      <span className="flex items-center text-sm text-gray-500">
                        <Clock className="w-4 h-4 mr-1" />
                        {new Date(log.created_at).toLocaleString()}
                      </span>
                    </div>

                    {Object.keys(details).length > 0 && (
                      <div className="mt-3 text-sm text-gray-700 bg-gray-50 p-3 rounded-lg">
                        <p className="font-medium text-gray-600 mb-1">Details:</p>
                        <div className="flex flex-wrap gap-3">
                          {Object.entries(details).map(([k, v]) => (
                            <span
                              key={k}
                              className="px-2 py-1 text-xs bg-white border rounded-md text-gray-700 shadow-sm"
                            >
                              <b>{k}:</b> {v}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetail;
